import { useSelector } from 'react-redux';
import { ncFileStatuses } from '@helpers';
import { TimeCategory } from '@interfaces/base';
import type { ProductionBatchStatistics } from '@interfaces/search';
import { selectIsWithERP } from '@reducers/membership';
import { filterTimeCategoriesData } from '@v2/pages/common/helpers/filterTimeCategoriesData';

export interface FilterTimeCategoriesDataParams<T> {
  data: T[];
  batch: ProductionBatchStatistics | null;
  ncFileStatus?: (typeof ncFileStatuses)[keyof typeof ncFileStatuses];
  skipItems?: number;
  allowedTimeCategories?: TimeCategory[];
}

export const useFilterTimeCategoriesData = <T extends { name: TimeCategory }>({
  data,
  batch,
  ncFileStatus: ncFileStatusFromParams,
  allowedTimeCategories,
  skipItems = 0,
}: FilterTimeCategoriesDataParams<T>) => {
  const isWithERP = useSelector(selectIsWithERP);

  return filterTimeCategoriesData({
    data,
    batch,
    isWithERP,
    ncFileStatus: ncFileStatusFromParams,
    allowedTimeCategories,
    skipItems,
  });
};
